export const theme = {
  colors: {
    background: "#F2F5F8",
    text: "#212227",
    secondaryText: "#98A0AC",
    accent: "#126DC8",
    grey: "#DCDDE0",
    darkBlue: "#212227",
    controls: "#2122274D",
    greyBlue: "#4C596E",
    lightGreyBlue: "#5D697C",
    lightBlue: "#E3EBF3",
    offWhite: "#F2F5F8",
    white: "#FFFFFF",
    green: "#3ABC19",
    darkGreen: "#196B05",
    darkMediumGreen: "#B2F4A1",
    mediumGreen: "#84CC73",
    lightMediumGreen: "#CBFBBF",
    lightGreen: "#EDFFEF",
    darkRed: "#B4210D",
    mediumRed: "#FFD8CE",
    lightRed: "#FFF2EF",
    scrollbar: "#DCDDE0",
    scrollbarHover: "#4C596E66",
  },
  spacing: {
    xsmall: "5px",
    small: "10px",
    regular: "20px",
    medium: "40px",
    large: "82px",
    spacingTablet: "120px",
    spacingDesktop: "164px",
  },
  padding: {
    xsmall: "5px",
    small: "10px",
    regular: "20px",
    medium: "30px",
    large: "40px",
    xlarge: "82px",
    button: "16px 32px",
    buttonLarge: "20px 46px",
    buttonXLarge: "24px 52px",
    body: "30px",
    container: "20px",
    buttonMobile: "12px 24px",
  },
  shadow: {
    xsmall: "0 4px 20px rgba(191, 191, 191, 0.25)",
    small: "0 4 8px rgba(33, 34, 39, 0.1)",
    medium: "-12px 12px 20px 12px rgba(33, 34, 39, 0.2)",
    card: "0 8px 20px 0 rgba(191, 191, 191, 0.25)",
    cardHover: "0 0 16px 0 rgba(18, 109, 200, 0.45)",
    buttonFocus:
      "0 0 0 3px rgba(18, 109, 200, 0.45), 0 8px 20px rgba(18, 109, 200, 0.32)",
    buttonActive:
      "0 0 0 4px rgba(18, 109, 200, 0.38), 0 10px 28px rgba(18, 109, 200, 0.58)",
  },
  borderRadius: {
    xsmall: "5px",
    small: "10px",
    regular: "16px",
    medium: "20px",
    large: "30px",
    xlarge: "40px",
  },
  typography: {
    h1: {
      fontSize: "3rem",
      fontWeight: 800,
    },
    h2: {
      fontSize: "2rem",
      fontWeight: 600,
    },
    h3: {
      fontSize: "1.75rem",
      fontWeight: 600,
    },
    body: {
      fontSize: "1.25rem",
      fontWeight: 500,
    },
    medium: {
      fontSize: "1rem",
      fontWeight: 500,
    },
    regular: {
      fontSize: "0.875rem",
      fontWeight: 400,
    },
    small: {
      fontSize: "0.75rem",
      fontWeight: 400,
    },
  },
  fontWeight: {
    extralight: 200,
    light: 300,
    regular: 400,
    medium: 500,
    semibold: 600,
    bold: 700,
    extrabold: 800,
  },
};

export type Theme = typeof theme;
